<template lang="pug">
a.btn.btn-icon.btn-naked(
  v-tooltip
  data-placement="left"
  data-original-title="Download screenshots"
  @click="showDownloadScreenshotsDialog"
)
  i.hi.hi-16.hi-export
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActivitiesDownloadButton',
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['currentZone']),
  },
  methods: {
    showDownloadScreenshotsDialog() {
      AjaxDialog.run(
        `/organizations/${this.organizationId}/exports/new.dialog?selected_user_id=${this.userId}&time_zone=${encodeURIComponent(this.currentZone.name)}`,
      );
    },
  },
};
</script>
